<div class="search__body" [ngClass]="{'mobile-search': location == 'mobile-header'}">
    <form [formGroup]="form" class="search__form">
        <!-- <select
            *ngIf="location === 'header'"
            class="search__categories"
            aria-label="Category"
            formControlName="category"
            (focus)="closeSuggestion()"
        >
            <option value="all">All Categories</option>
            <option
                *ngFor="let category of categories"
                [value]="category.name.en"
                [innerHTML]="getCategoryName(category)"
            ></option>
        </select> -->
        <button *ngIf="location === 'mobile-header'" class="search__button search__button--type--close" type="button" (click)="closeSuggestion(); closeSearchDropdown();">
            <!-- <app-icon [name]="translate.currentLang == 'ar'? 'arrow-rounded-right-8x13' : 'arrow-rounded-left-8x13'" size="20"></app-icon> -->
            <img class="back-button" [src]="translate.currentLang == 'ar'? 'assets/svg/arrow_forward.svg' : 'assets/svg/arrow_back.svg'" width="24">
        </button>
        <button (click)="openSearchPage()" class="search__button search__button--type--submit" type="submit">
            <app-icon name="search-20" size="20"></app-icon>
        </button>
    
        <input class="search__input" name="search" [placeholder]="(location === 'page-header' && sector)?(('search_in'|translate)+' '+translateHelper.localize(sector.name)):('search_over'|translate)" aria-label="Site search" type="text" autocomplete="off" formControlName="q" (keydown.escape)="escape.next()"
            (focus)="openSuggestion()" #input>

        <div class="search__border"></div>
    </form>

    <div class="search__suggestions suggestions suggestions--location--{{ location }}">
        <div class="flex flex-col empty-state" *ngIf="suggestedProducts.length == 0 && suggestedCompanies.length == 0 && suggestedCategories.length == 0 && this.suggestedProperties.length == 0; else result_tabs">
            <div class="text-center p-5">
                <img src="assets/svg/search-empty-icon.svg">
                <!-- <p>{{input.value.length ? "Couldn't find results" : "Enter your search query"}}</p> -->
            </div>
        </div>

        <ng-template #result_tabs>
            <mat-tab-group animationDuration="300ms" [selectedIndex]="index">
                <mat-tab [label]="'Items'|translate" *ngIf="suggestedProducts.length > 0">
                    <div class="result-container">
                        <div class="flex flex-col" *ngIf="suggestedProducts.length > 0">
                            <ul class="suggestions__list">
                                <li *ngFor="let product of suggestedProducts" class="suggestions__item">
                                    <div class="suggestions__item-image product-image">
                                        <div class="product-image__body">
                                            <img class="product-image__img" [src]="imagebObjectKey(product.images) ? product.images[imagebObjectKey(product.images)].icon?.url|| product.images[imagebObjectKey(product.images)].url : image " alt="">
                                        </div>
                                    </div>
                                    <div class="suggestions__item-info">
                                        <a [routerLink]="((product.sector?.seo?.slug) ? ['/', translate.currentLang,'sector', product.sector?.seo?.slug] : ['/']).concat([(product.layout && product.layout!='product')?product.layout:product.type || 'product', product.seo?.slug])" class="suggestions__item-name"
                                            (click)="closeSuggestion(); closeSearchDropdown(); scrollToTop();">
                                            {{ translateHelper.localize(product.name) }}
                                        </a>
                                        <div class="suggestions__item-meta">SKU: {{ product.code }}</div>
                                    </div>
                                    <div class="suggestions__item-price" *ngIf="!product.hidePrice">
                                        {{ product.taxedPrice || product.price|currencyConvert : product.companyData.currencyMeta.code }}
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <div class="flex flex-col empty-state" *ngIf="suggestedProducts.length == 0">
                            <div class="text-center p-5">
                                <img src="assets/svg/search-empty-icon.svg">
                                <p class="mt-3">{{"Couldn't find items"|translate}}</p>
                            </div>
                        </div>
                    </div>
                </mat-tab>
                <mat-tab [label]="'properties'|translate" *ngIf="suggestedProperties.length > 0">
                    <div class="result-container">
                        <div class="flex flex-col" *ngIf="suggestedProperties.length > 0">
                            <ul class="suggestions__list">
                                <li *ngFor="let property of suggestedProperties" class="suggestions__item">
                                    <div class="suggestions__item-image product-image">
                                        <div class="product-image__body">
                                            <img class="product-image__img" [src]="imagebObjectKey(property.images) ? property.images[imagebObjectKey(property.images)].icon?.url|| property.images[imagebObjectKey(property.images)].url : image " alt="">
                                        </div>
                                    </div>
                                    <div class="suggestions__item-info">
                                        <a [routerLink]="((property.sector?.seo?.slug) ? ['/', translate.currentLang,'sector', property.sector?.seo?.slug] : ['/']).concat([(property.layout && property.layout!='product')?property.layout:property.type || 'product', property.seo?.slug])" class="suggestions__item-name"
                                            (click)="closeSuggestion(); closeSearchDropdown(); scrollToTop();">
                                            {{ translateHelper.localize(property.name) }}
                                        </a>
                                        <div class="suggestions__item-meta">SKU: {{ property.code }}</div>
                                    </div>
                                    <div class="suggestions__item-price" *ngIf="!property.hidePrice">
                                        <ng-container *ngIf="property?.realEstate?.displayPrice?.priceType == 'exact'">
                                            <span class="current-price">{{property.realEstate?.displayPrice?.price|currencyConvert : product.companyData.currencyMeta.code}}</span>
                                        </ng-container>
                                        <ng-container *ngIf="property?.realEstate?.displayPrice?.priceType == 'range'">
                                            <span class="current-price">{{property.realEstate?.displayPrice?.priceRange?.min|currencyConvert : product.companyData.currencyMeta.code}} - {{property.realEstate?.displayPrice?.priceRange?.max|currencyConvert : product.companyData.currencyMeta.code}}</span>
                                        </ng-container>
                                        <ng-container *ngIf="property?.realEstate?.displayPrice?.priceType == 'from'">
                                            <span class="current-price">{{"starting_from"|translate}} {{property.realEstate?.displayPrice?.price|currencyConvert : product.companyData.currencyMeta.code}}</span>
                                        </ng-container>
                                        <small class="font-weight-bold text-capitalize" *ngIf="property?.realEstate?.displayPrice?.propertyType =='rent' && property?.realEstate?.displayPrice?.rentType">
                                            / {{property?.realEstate?.displayPrice?.rentType}}
                                        </small>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <div class="flex flex-col empty-state" *ngIf="suggestedProperties.length == 0">
                            <div class="text-center p-5">
                                <img src="assets/svg/search-empty-icon.svg">
                                <p class="mt-3">{{"Couldn't find items"|translate}}</p>
                            </div>
                        </div>
                    </div>
                </mat-tab>
                <mat-tab [label]="'stores'|translate" *ngIf="suggestedCompanies.length > 0">
                    <div class="result-container">
                        <div class="flex flex-col" *ngIf="suggestedCompanies.length > 0">
                            <ul class="suggestions__list">
                                <li *ngFor="let company of suggestedCompanies" class="suggestions__item">
                                    <div class="suggestions__item-image product-image">
                                        <div class="product-image__body">
                                            <img class="product-image__img" [src]="company.design?.logo?.url? company.design?.logo?.url : image " alt="">
                                        </div>
                                    </div>
                                    <div class="suggestions__item-info">
                                        <a [routerLink]="['/','vendor', company.seo?.slug]" class="suggestions__item-name" (click)="closeSuggestion(); closeSearchDropdown(); scrollToTop();">
                                            {{ translateHelper.localize(company.name) }}
                                        </a>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <div class="flex flex-col empty-state" *ngIf="suggestedCompanies.length == 0">
                            <div class="text-center p-5">
                                <img src="assets/svg/search-empty-icon.svg">
                                <p class="mt-3">{{"Couldn't find stores"|translate}}</p>
                            </div>
                        </div>
                    </div>
                </mat-tab>
                <!-- <mat-tab [label]="'categories'|translate">
                    <div class="result-container">
                        <div class="flex flex-col" *ngIf="suggestedCategories.length > 0">
                            <ul class="suggestions__list">
                                <li *ngFor="let category of suggestedCategories" class="suggestions__item">
                                    <div class="suggestions__item-image product-image">
                                        <div class="product-image__body">
                                            <img class="product-image__img" [src]="category.thumbnail?.url? category.thumbnail?.url : category.icon?.url? category.icon?.url : image " alt="">
                                        </div>
                                    </div>
                                    <div class="suggestions__item-info">
                                        <a [routerLink]="((category.sectorData && category.sectorData.length) ? ['/sector', category.sectorData[0].seo.slug] : ['/']).concat(['category', category.seo?.slug])" class="suggestions__item-name" (click)="closeSuggestion(); closeSearchDropdown(); scrollToTop();">
                                            {{ translateHelper.localize(category.name) }}
                                        </a>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <div class="flex flex-col empty-state" *ngIf="suggestedCategories.length == 0">
                            <div class="text-center p-5">
                                <img src="assets/svg/search-empty-icon.svg">
                                <p class="mt-3">{{"Couldn't find categories"|translate}}</p>
                            </div>
                        </div>
                    </div>
                </mat-tab> -->
            </mat-tab-group>
        </ng-template>
    </div>
</div>